export const DATE_FORMAT_DATE = 'YYYY-MM-DD';
export const DATE_FORMAT_DATE_TABLE = 'DD-MM-YYYY';
export const DATE_FORMAT_DATE_TIME = 'YYYY-MM-DD hh:mm:ss';
export const API_DATE_FORMAT_DATE = 'DD/MM/YYYY';
